const NAMESPACE_PREFIX = 'NOTIFICATION_MODAL'

export const NOTIFICATION_MODAL = {
    OPEN: `${NAMESPACE_PREFIX}.OPEN`,
    CLOSE: `${NAMESPACE_PREFIX}.CLOSE`,
}
